import { useEffect, useState } from "react";
import About from "../about/About";
import Carousel from "../carousel/Carousel";
import ScrollAnnouncement from "./ScrollAnnouncement";
import axios from "axios";
import Loader from "./Loader";


const Home = () => {
  // const [banner, setBanner] = useState([]);
  const [videoUrl, setVideoUrl] = useState(null);

  const getHomeCarouselVideo = async () => {
    try {
      const url = `${process.env.REACT_APP_API}/viewweb/getwebcarousel_video`;
      const res = await axios.get(url);
      setVideoUrl(res?.data?.data[0]?.path)
    } catch (error) {
      console.log(error)
    }
  }

  useEffect(() => {
    getHomeCarouselVideo();
  }, [])
  if (videoUrl === null) return <Loader open={videoUrl} text="Please wait...." />
  return (
    <>
      <div className="">
        <div className="bg-yellow-500 pt-0 pb-1">
          <div className="scroll">
            <div className="scroll-content">
              <ScrollAnnouncement />
            </div>
          </div>
        </div>
          <div className="flex flex-col md:flex-row w-full">
          <div className="w-full">
            <Carousel />
          </div>
        </div>
        {/* <div className="flex flex-col md:flex-row w-full">
          <div className="w-full md:w-2/3">
            <Carousel />
          </div>
          <div className="w-full md:w-1/3  h-auto">
            <video
              autoPlay
              muted
              loop
              playsInline
              className=" w-full object-cover"
            >
              <source src={videoUrl} type="video/mp4" />
            </video>
          </div>
        </div> */}
        {/* <div className="flex flex-col md:flex-row lg:flex-row xl:row 2xl:flex-row ">
          {banner.map((image, index) => (
            <a
              href={image.url}
              className=" w-full md:w-[50%] object-cover  "
              target="_blank"
              rel="noreferrer"
            >
              <img src={image.signedUrl} alt={image.alt} className="h-full" />
            </a>
          ))}
        </div> */}
      </div>
      <About />
    </>
  );
};

export default Home;
